module.exports = __webpack_public_path__ + "static/media/AvatarOka.5a41ab98.png";